'use strict';

var CompletionRecord = require('es-abstract/2024/CompletionRecord');

// https://tc39.es/ecma262/#sec-returncompletion

module.exports = function ReturnCompletion(value) {
	return new CompletionRecord('return', value);
};
